import {
  createComponentMapperModel,
  withCompInfo,
} from '@wix/editor-elements-integrations';
import { getLanguage } from '../../WTwitter/common/utils';
import {
  WTwitterFollowDefinition,
  WTwitterFollowProps,
} from '../WTwitterFollow.types';

export const props = withCompInfo<
  WTwitterFollowProps,
  WTwitterFollowDefinition
>()(
  ['compData', 'compProps', 'compLayout', 'language'],
  ({ compData, compProps, compLayout, language }) => {
    return {
      showCount: compProps.showCount.toString(),
      showScreenName: compProps.showScreenName.toString(),
      accountToFollow: compData.accountToFollow.replace('@', ''),
      lang: getLanguage(compProps.dataLang, language),
      width: compLayout.width || 0,
      height: compLayout.height || 0,
    };
  },
);

export default createComponentMapperModel({ props });
